export enum Language {
  English = 'en',
  Turkish = 'tr',
}
